import {Button, ButtonProps, UnstableCard as Paper} from '@logistics-frontend/blocks'
import React, {memo} from 'react'

import * as classes from './FloatingButton.classes'

type FloatingButtonProps = Omit<ButtonProps, 'm' | 'mb' | 'ml' | 'mr' | 'mt' | 'mx' | 'my' | 'variant'>

export const FloatingButton = memo(
  ({children, ...props}: FloatingButtonProps): React.ReactElement => (
    <Paper className={classes.floatingButtonWrapper} padding="S">
      <Button {...props} variant="action">
        {children}
      </Button>
    </Paper>
  ),
)
